import { render, staticRenderFns } from "./Telegram.vue?vue&type=template&id=eb31deac&"
import script from "./Telegram.vue?vue&type=script&lang=js&"
export * from "./Telegram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eb31deac')) {
      api.createRecord('eb31deac', component.options)
    } else {
      api.reload('eb31deac', component.options)
    }
    module.hot.accept("./Telegram.vue?vue&type=template&id=eb31deac&", function () {
      api.rerender('eb31deac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/inbox/channels/Telegram.vue"
export default component.exports